import React from 'react';
import PropTypes from 'prop-types';
import { t, Trans } from '@lingui/macro';
import { P, RadioGroup } from '@decisiv/ui-components';

export default function CacheFilter({ handleForm, currentValue }) {
  return (
    <>
      <P marginBottom={1}>
        <Trans>Cache</Trans>
      </P>
      <RadioGroup
        marginBottom={1}
        name="radio_cache"
        items={[
          { label: t`Both`, value: 'Both' },
          { label: t`Enabled`, value: 'Cache Enabled' },
          { label: t`Disabled`, value: 'Cache Disabled' },
        ]}
        vertical
        value={currentValue}
        onChange={(e) => {
          handleForm({ event: e, field: 'cache' });
        }}
      />
    </>
  );
}

CacheFilter.propTypes = {
  handleForm: PropTypes.func.isRequired,
  currentValue: PropTypes.string.isRequired,
};
